import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const PackageComparison = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const features = [
    {
      category: 'Sosyal Medya Yönetimi',
      items: [
        { name: 'Post Tasarımı', basic: '8 Adet', standard: '12 Adet', premium: '16 Adet' },
        { name: 'Story İçeriği', basic: '4 Adet', standard: '8 Adet', premium: '12 Adet' },
        { name: 'İçerik Stratejisi', basic: 'Temel', standard: 'Gelişmiş', premium: 'Trend Odaklı' },
        { name: 'Moderasyon', basic: false, standard: true, premium: true },
        { name: 'Topluluk Yönetimi', basic: false, standard: false, premium: true },
        { name: 'Raporlama', basic: 'Aylık', standard: 'Haftalık', premium: 'Günlük' },
      ],
    },
    {
      category: 'Reklam Yönetimi',
      items: [
        { name: 'Kampanya Sayısı', basic: '1 Kampanya', standard: '3 Kampanya', premium: 'Çoklu Kampanya' },
        { name: 'Pixel & Analytics', basic: false, standard: true, premium: true },
        { name: 'Dönüşüm Optimizasyonu', basic: 'Temel', standard: 'Gelişmiş', premium: 'İleri Seviye' },
        { name: 'A/B Testleri', basic: false, standard: 'Başlangıç', premium: 'İleri Testler' },
        { name: 'Remarketing', basic: false, standard: false, premium: true },
        { name: 'ROI Optimizasyonu', basic: false, standard: false, premium: true },
      ],
    },
    {
      category: 'Web Tasarım',
      items: [
        { name: 'Sayfa Sayısı', basic: '1-5 Sayfa', standard: '5-10 Sayfa', premium: '10+ Sayfa' },
        { name: 'Responsive Tasarım', basic: true, standard: true, premium: true },
        { name: 'SSL Sertifikası', basic: true, standard: true, premium: true },
        { name: 'Form Otomasyonu', basic: false, standard: true, premium: true },
        { name: 'SEO Optimizasyon', basic: 'Temel', standard: 'Temel', premium: 'Premium' },
        { name: 'Çoklu Dil Desteği', basic: false, standard: false, premium: true },
        { name: 'API Entegrasyonu', basic: false, standard: false, premium: true },
      ],
    },
    {
      category: 'CRM & Otomasyon',
      items: [
        { name: 'Müşteri Kayıt Sistemi', basic: 'Temel', standard: 'Gelişmiş', premium: 'AI Destekli' },
        { name: 'Pipeline Yönetimi', basic: true, standard: true, premium: true },
        { name: 'Segmentasyon', basic: false, standard: true, premium: 'Akıllı' },
        { name: 'Otomatik Teklif', basic: false, standard: true, premium: true },
        { name: 'E-posta & SMS Akışı', basic: false, standard: true, premium: true },
        { name: 'ERP Entegrasyonu', basic: false, standard: false, premium: true },
        { name: 'Tahmine Dayalı Analiz', basic: false, standard: false, premium: true },
      ],
    },
    {
      category: 'Marka Kimliği',
      items: [
        { name: 'Logo Tasarımı', basic: 'Profesyonel', standard: 'Profesyonel', premium: 'Premium' },
        { name: 'Renk Paleti', basic: true, standard: true, premium: true },
        { name: 'Tipografi Seti', basic: true, standard: true, premium: true },
        { name: 'Kurumsal Evrak', basic: false, standard: true, premium: true },
        { name: 'Marka Rehberi', basic: 'Temel', standard: 'Mini', premium: 'Tam Kılavuz' },
        { name: 'Sosyal Medya Kit', basic: false, standard: false, premium: true },
        { name: 'Araç Giydirme', basic: false, standard: false, premium: true },
        { name: 'Marka Workshop', basic: false, standard: false, premium: true },
      ],
    },
    {
      category: 'Video İçerik',
      items: [
        { name: 'Reel Video', basic: '2 Adet', standard: '4 Adet', premium: '6 Adet' },
        { name: 'Montaj Kalitesi', basic: 'Temel', standard: 'Profesyonel', premium: 'Premium' },
        { name: 'Motion Graphic', basic: false, standard: true, premium: true },
        { name: 'Profesyonel Çekim', basic: false, standard: false, premium: true },
        { name: 'Senaryo Yazımı', basic: false, standard: false, premium: true },
        { name: 'İleri Efekt & Animasyon', basic: false, standard: false, premium: true },
      ],
    },
    {
      category: 'Destek & Raporlama',
      items: [
        { name: 'Performans Raporu', basic: 'Aylık', standard: 'Haftalık', premium: 'Haftalık' },
        { name: 'Strateji Toplantısı', basic: false, standard: 'Aylık', premium: 'Haftalık' },
        { name: 'Gelişim Sunumu', basic: false, standard: true, premium: true },
        { name: 'Öncelikli Destek', basic: false, standard: true, premium: true },
        { name: 'Özel Danışmanlık', basic: false, standard: false, premium: true },
      ],
    },
  ];

  const packages = [
    { name: 'Başlangıç', price: '64.000 TL', color: 'bg-[#007dff]' },
    { name: 'Profesyonel', price: '89.000 TL', color: 'bg-[#007dff]' },
    { name: 'Premium', price: '116.280 TL', color: 'bg-[#007dff]' },
  ];

  const renderCell = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return value ? (
        <div className="w-5 h-5 flex items-center justify-center bg-[#007dff]/10 rounded-full mx-auto">
          <i className="ri-check-line text-[#007dff] text-sm"></i>
        </div>
      ) : (
        <div className="w-5 h-5 flex items-center justify-center bg-gray-100 rounded-full mx-auto">
          <i className="ri-close-line text-gray-400 text-sm"></i>
        </div>
      );
    }
    return (
      <span className="font-poppins text-xs text-gray-700 font-medium">{value}</span>
    );
  };

  return (
    <section ref={ref} className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-[1440px] mx-auto px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-poppins font-bold text-3xl lg:text-4xl text-gray-900 mb-4">
            Detaylı Paket Karşılaştırması
          </h2>
          <p className="font-poppins text-base text-gray-600 max-w-2xl mx-auto">
            Hangi paketin ihtiyaçlarınıza en uygun olduğunu detaylı karşılaştırma tablosu ile keşfedin
          </p>
        </motion.div>

        {/* Comparison Table */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200"
        >
          {/* Table Header */}
          <div className="grid grid-cols-4 gap-4 p-6 bg-gradient-to-r from-[#007dff] to-[#0066dd]">
            <div className="font-poppins font-bold text-sm text-white">Özellikler</div>
            {packages.map((pkg, idx) => (
              <div key={idx} className="text-center">
                <div className="font-poppins font-bold text-sm text-white mb-1">{pkg.name}</div>
                <div className="font-poppins text-xs text-white/80">{pkg.price}</div>
              </div>
            ))}
          </div>

          {/* Table Body */}
          <div className="divide-y divide-gray-200">
            {features.map((category, catIdx) => (
              <div key={catIdx}>
                {/* Category Header */}
                <div className="bg-gray-50 px-6 py-3">
                  <h3 className="font-poppins font-bold text-sm text-gray-900 flex items-center gap-2">
                    <div className="w-1 h-4 bg-[#007dff] rounded-full"></div>
                    {category.category}
                  </h3>
                </div>

                {/* Category Items */}
                {category.items.map((item, itemIdx) => (
                  <div
                    key={itemIdx}
                    className="grid grid-cols-4 gap-4 px-6 py-4 hover:bg-gray-50 transition-colors duration-200"
                  >
                    <div className="font-poppins text-xs text-gray-700">{item.name}</div>
                    <div className="text-center">{renderCell(item.basic)}</div>
                    <div className="text-center">{renderCell(item.standard)}</div>
                    <div className="text-center">{renderCell(item.premium)}</div>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* Table Footer */}
          <div className="grid grid-cols-4 gap-4 p-6 bg-gray-50 border-t-2 border-[#007dff]">
            <div className="font-poppins font-bold text-sm text-gray-900">Toplam Değer</div>
            <div className="text-center">
              <div className="font-poppins text-xs text-gray-500 line-through mb-1">79.000 TL</div>
              <span className="font-poppins font-bold text-lg text-[#007dff]">64.000 TL</span>
              <div className="font-poppins text-xs text-green-600 mt-1">%19 İndirim</div>
            </div>
            <div className="text-center">
              <div className="font-poppins text-xs text-gray-500 line-through mb-1">114.000 TL</div>
              <span className="font-poppins font-bold text-lg text-[#007dff]">89.000 TL</span>
              <div className="font-poppins text-xs text-green-600 mt-1">%22 İndirim</div>
            </div>
            <div className="text-center">
              <div className="font-poppins text-xs text-gray-500 line-through mb-1">161.500 TL</div>
              <span className="font-poppins font-bold text-lg text-[#007dff]">116.280 TL</span>
              <div className="font-poppins text-xs text-green-600 mt-1">%28 İndirim</div>
            </div>
          </div>
        </motion.div>

        {/* Info Cards */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="grid md:grid-cols-3 gap-6 mt-12"
        >
          {[
            {
              icon: 'ri-shield-check-line',
              title: 'Ödeme Güvencesi',
              desc: 'Tüm ödemeleriniz güvenli ödeme sistemleri ile korunur',
            },
            {
              icon: 'ri-time-line',
              title: 'Hızlı Başlangıç',
              desc: 'Sözleşme sonrası 3-5 iş günü içinde projeniz başlar',
            },
            {
              icon: 'ri-customer-service-2-line',
              title: 'Öncelikli Destek',
              desc: 'Tüm paketlerde profesyonel müşteri desteği sunuyoruz',
            },
          ].map((info, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#007dff] hover:shadow-lg transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#007dff]/10 rounded-xl mb-4">
                <i className={`${info.icon} text-[#007dff] text-2xl`}></i>
              </div>
              <h3 className="font-poppins font-bold text-base text-gray-900 mb-2">{info.title}</h3>
              <p className="font-poppins text-sm text-gray-600">{info.desc}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default PackageComparison;
